import * as React from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { CustomLabel } from '../../common/custom-label';
import { UniqueRequestMessageCreateDialog } from './unique-request-message-create-dialog';
import { UniqueRequestMessageShow } from './unique-request-message-show';
import {
    UniqueRequest,
    UniqueRequestMessageOrigin,
} from '../../models/unique-request';
import { useTheme } from '@mui/material/styles';
import { WorkStatusType } from '../../models/work-status';
import { useState } from 'react';

export const UniqueRequestMessageList = ({
    record,
}: {
    record: UniqueRequest;
}) => {
    const theme = useTheme();
    const [dialogOpen, setDialogOpen] = useState(false);
    const isClosed = record.status.status === WorkStatusType.Closed;

    return (
        <Box>
            <CustomLabel>Üzenetek</CustomLabel>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    marginTop: 1,
                    width: {
                        xs: '100%',
                        md: '50%',
                    },
                }}
            >
                {record.messages?.map((message) => {
                    const isIncoming =
                        message.origin === UniqueRequestMessageOrigin.Web;

                    const sender = isIncoming
                        ? record.user
                        : (message.admin ?? null);

                    return (
                        <UniqueRequestMessageShow
                            key={message.id}
                            status={record.status.status}
                            sender={sender}
                            message={message}
                        />
                    );
                })}
                {!record.messages?.length && (
                    <Box
                        textAlign={'center'}
                        sx={{
                            color: theme.palette.grey['600'],
                            backgroundColor: theme.palette.grey['100'],
                            padding: 2,
                            border: 1,
                            borderRadius: 1,
                            borderColor: theme.palette.grey['300'],
                        }}
                    >
                        <Typography variant="body2">
                            Nincsenek üzenetek.
                        </Typography>
                    </Box>
                )}
                <Box>
                    <Tooltip
                        title="Lezárt ügyhöz nem lehet új üzenetet írni."
                        disableHoverListener={!isClosed}
                    >
                        <span>
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={() => setDialogOpen(true)}
                                disabled={isClosed}
                            >
                                Üzenet írása
                            </Button>
                        </span>
                    </Tooltip>
                </Box>
            </Box>
            <UniqueRequestMessageCreateDialog
                uniqueRequestId={record.id}
                open={dialogOpen}
                setOpen={setDialogOpen}
            />
        </Box>
    );
};
